"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BubbleFocusTrigger = void 0;
var tslib_1 = require("tslib");
// (C) 2020 GoodData Corporation
var BubbleTrigger_1 = require("./BubbleTrigger");
/**
 * @internal
 */
var BubbleFocusTrigger = /** @class */ (function (_super) {
    tslib_1.__extends(BubbleFocusTrigger, _super);
    function BubbleFocusTrigger() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BubbleFocusTrigger.prototype.eventListeners = function () {
        return {
            onFocus: this.changeBubbleVisibility.bind(this, true),
            onBlur: this.changeBubbleVisibility.bind(this, false),
        };
    };
    BubbleFocusTrigger.defaultProps = {
        tagName: "span",
        eventsOnBubble: true,
    };
    return BubbleFocusTrigger;
}(BubbleTrigger_1.BubbleTrigger));
exports.BubbleFocusTrigger = BubbleFocusTrigger;
//# sourceMappingURL=BubbleFocusTrigger.js.map